var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 40,
    viewBox: "0 0 92 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_153_1829)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 88,
    height: 36,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 87,
    height: 35,
    rx: 7.5,
    stroke: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3366 13.8182V24H23.9247L18.7493 16.5327H18.6548V24H17.1186V13.8182H18.5405L23.7209 21.2955H23.8153V13.8182H25.3366ZM30.7495 24.1541C29.9971 24.1541 29.3491 23.9934 28.8056 23.6719C28.2653 23.3471 27.8477 22.8913 27.5527 22.3047C27.2611 21.7147 27.1152 21.0237 27.1152 20.2315C27.1152 19.4493 27.2611 18.7599 27.5527 18.1634C27.8477 17.5668 28.2587 17.1011 28.7857 16.7663C29.316 16.4316 29.9358 16.2642 30.6451 16.2642C31.0759 16.2642 31.4935 16.3355 31.8979 16.478C32.3023 16.6205 32.6652 16.8442 32.9867 17.1491C33.3082 17.4541 33.5617 17.8501 33.7473 18.3374C33.9329 18.8213 34.0257 19.4096 34.0257 20.1023V20.6293H27.9554V19.5156H32.5691C32.5691 19.1245 32.4895 18.7782 32.3304 18.4766C32.1713 18.1716 31.9476 17.9313 31.6593 17.7557C31.3742 17.58 31.0395 17.4922 30.655 17.4922C30.2374 17.4922 29.8728 17.5949 29.5613 17.8004C29.253 18.0026 29.0144 18.2678 28.8453 18.5959C28.6796 18.9207 28.5968 19.2737 28.5968 19.6548V20.5249C28.5968 21.0353 28.6863 21.4695 28.8652 21.8274C29.0475 22.1854 29.3011 22.4588 29.6259 22.6477C29.9507 22.8333 30.3302 22.9261 30.7644 22.9261C31.0461 22.9261 31.303 22.8864 31.535 22.8068C31.767 22.724 31.9675 22.6013 32.1365 22.4389C32.3056 22.2765 32.4348 22.076 32.5243 21.8374L33.9313 22.0909C33.8186 22.5052 33.6164 22.8681 33.3248 23.1797C33.0364 23.4879 32.6735 23.7282 32.236 23.9006C31.8018 24.0696 31.3063 24.1541 30.7495 24.1541ZM36.6706 16.3636L38.356 19.3366L40.0563 16.3636H41.682L39.3006 20.1818L41.7019 24H40.0762L38.356 21.1463L36.6408 24H35.0101L37.3865 20.1818L35.04 16.3636H36.6706ZM46.7729 16.3636V17.5568H42.6017V16.3636H46.7729ZM43.7203 14.5341H45.2069V21.7578C45.2069 22.0462 45.2499 22.2633 45.3361 22.4091C45.4223 22.5516 45.5333 22.6494 45.6692 22.7024C45.8084 22.7521 45.9592 22.777 46.1216 22.777C46.2409 22.777 46.3453 22.7687 46.4348 22.7521C46.5243 22.7356 46.5939 22.7223 46.6436 22.7124L46.9121 23.9403C46.8259 23.9735 46.7033 24.0066 46.5442 24.0398C46.3851 24.0762 46.1863 24.0961 45.9476 24.0994C45.5565 24.1061 45.1919 24.0365 44.8539 23.8906C44.5158 23.7448 44.2424 23.5194 44.0336 23.2145C43.8248 22.9096 43.7203 22.5268 43.7203 22.0661V14.5341Z",
    fill: "#344054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1667 19H71.8334M71.8334 19L66.0001 13.1667M71.8334 19L66.0001 24.8334",
    stroke: "#344054",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_153_1829",
    x: 0,
    y: 0,
    width: 92,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_153_1829"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_153_1829",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextCard);
export default __webpack_public_path__ + "static/media/nextCard.8558272b842dcd6f544b7344687af1a9.svg";
export { ForwardRef as ReactComponent };